// Этот файл генерируется автоматически, его не следует редактировать вручную
import anchorMobileApp from '@/widgets/anchorMobileApp.js';
import anchorPopup from '@/widgets/anchorPopup.js';
import awardsSliders from '@/widgets/awardsSliders.js';
import clearForm from '@/widgets/clearForm.js';
import cursorGradient from '@/widgets/cursorGradient.js';
import form from '@/widgets/form.js';
import formsConditional from '@/widgets/formsConditional.js';
import infoPopup from '@/widgets/infoPopup.js';
import offersCarousel from '@/widgets/offersCarousel.js';
import pathFormSubmit from '@/widgets/pathFormSubmit.js';
import popup from '@/widgets/popup.js';
import revealPinnedMenu from '@/widgets/revealPinnedMenu.js';
import scrollerHorizontal from '@/widgets/scrollerHorizontal.js';
import searchToggle from '@/widgets/searchToggle.js';
import selectNotEmpty from '@/widgets/selectNotEmpty.js';
import servicesAnchorLinks from '@/widgets/servicesAnchorLinks.js';
import servicesCard from '@/widgets/servicesCard.js';
import showPopupMenu from '@/widgets/showPopupMenu.js';
import slider from '@/widgets/slider.js';
import stickyHeader from '@/widgets/stickyHeader.js';
import stickyMobileHeader from '@/widgets/stickyMobileHeader.js';
import telField from '@/widgets/telField.js';
import testFlow from '@/widgets/testFlow.js';
import toggleClass from '@/widgets/toggleClass.js';
import upload from '@/widgets/upload.js';
import videoPlay from '@/widgets/videoPlay.js';

export default {
  'anchorMobileApp': async () => { return { default: anchorMobileApp }; },
  'anchorPopup': async () => { return { default: anchorPopup }; },
  'awardsSliders': async () => { return { default: awardsSliders }; },
  'clearForm': async () => { return { default: clearForm }; },
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'cursorGradient': async () => { return { default: cursorGradient }; },
  'dateRangeFilter': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/dateRangeFilter.js'),
  'dynamicDiagram': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/dynamicDiagram.js'),
  'faqSearch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/faqSearch.js'),
  'folder': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/folder.js'),
  'form': async () => { return { default: form }; },
  'formsConditional': async () => { return { default: formsConditional }; },
  'infoPopup': async () => { return { default: infoPopup }; },
  'map': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/map.js'),
  'offersCarousel': async () => { return { default: offersCarousel }; },
  'pathFormSubmit': async () => { return { default: pathFormSubmit }; },
  'popup': async () => { return { default: popup }; },
  'revealPinnedMenu': async () => { return { default: revealPinnedMenu }; },
  'scrollerHorizontal': async () => { return { default: scrollerHorizontal }; },
  'searchToggle': async () => { return { default: searchToggle }; },
  'selectNotEmpty': async () => { return { default: selectNotEmpty }; },
  'servicesAnchorLinks': async () => { return { default: servicesAnchorLinks }; },
  'servicesCard': async () => { return { default: servicesCard }; },
  'showPopupMenu': async () => { return { default: showPopupMenu }; },
  'signedForm': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "signedForm" */ '@/widgets/signedForm.js'),
  'slider': async () => { return { default: slider }; },
  'stickyHeader': async () => { return { default: stickyHeader }; },
  'stickyMobileHeader': async () => { return { default: stickyMobileHeader }; },
  'telField': async () => { return { default: telField }; },
  'testFlow': async () => { return { default: testFlow }; },
  'toggleClass': async () => { return { default: toggleClass }; },
  'upload': async () => { return { default: upload }; },
  'videoPlay': async () => { return { default: videoPlay }; }
};
